import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { CenterMediumContent, ContainedButton, Form, FormActions, FullScreenSpinner, MediumText, SmallText, TextBox } from '@guryou/html-components';
import { cognitoForgotPassword, FORGOT_PASSWORD, resetState, stateIsLoaded, StateStatus } from '@guryou/redux';

import './main.css';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const forgotPassword = useSelector(state => state.cognito.forgotPassword);
  const crossStorage = useSelector(state => state.crossStorage);

  useEffect(() => {
    if (crossStorage.client) {
      crossStorage.client.onConnect().then(() => crossStorage.client.del('access_token', 'refresh_token', 'providerId'));
    }
  }, [crossStorage.client]);

  if (forgotPassword.status === StateStatus.LOADING) {
    return <FullScreenSpinner />;
  }

  const handleSubmit = async ({ email }) => {
    dispatch(cognitoForgotPassword(email));
  };

  const handleGoToLogin = e => {
    e.preventDefault();
    dispatch(resetState(FORGOT_PASSWORD));
    history.push('/login');
  };

  return (
    <CenterMediumContent isPublicContent={false}>
      <div className="logoBg"></div>
      <Form className="login" onSubmit={handleSubmit} actions={false}>
        {stateIsLoaded(forgotPassword) ? (
          <MediumText textAlign="center">{t('CONFIRMATIONS.checkYourEmailForFurtherInstructions')}</MediumText>
        ) : (
          <>
            <h5 className="text-center">{t('GENERAL.resetPassword')}</h5>
            <TextBox name="email" label={t('GENERAL.email')} autoComplete="username" required />
          </>
        )}
        <FormActions>
          {!stateIsLoaded(forgotPassword) && (
            <ContainedButton style={{ backgroundColor: '#e6616a', color: 'white' }} type="submit" text={t('GENERAL.sendEmail')} />
          )}
          <br />
          <ContainedButton text={`${t('GENERAL.backToLogin')}`} onClick={handleGoToLogin} />
        </FormActions>
        <SmallText padding={2} color="red">
          {forgotPassword.error && forgotPassword.error.message}
        </SmallText>
      </Form>
    </CenterMediumContent>
  );
};

export default withRouter(ForgotPassword);
